// Platform console (super admin).
export default {
  "Rawaj Business": "رواج بزنس",
  "Rawaj Business Owner": "رواج بزنس للمالك",
  "Rawaj Business Platform": "منصة رواج بزنس",
  "Platform console": "لوحة المنصة",
  "Super admin": "المشرف العام",
  "My businesses": "أنشطتي التجارية",
  "Users": "المستخدمون",
  "Activity": "النشاط",
  "Trial": "فترة تجريبية",
  "Past due": "متأخر الدفع",
  "Canceled": "ملغى",
  "Incomplete": "غير مكتمل",
  "Online store": "متجر إلكتروني",
  "Rooms": "غرف",
  "Everything happening across the platform.": "كل ما يحدث على المنصة.",
  "{v0} active, {v1} suspended": "{v0} نشط، {v1} موقوف",
  "Monthly recurring revenue": "الإيراد الشهري المتكرر",
  "{v0} paying or on trial": "{v0} يدفع أو في فترة تجريبية",
  "New businesses (30 days)": "أنشطة جديدة (30 يومًا)",
  "{v0} owners, {v1} staff accounts": "{v0} مالك، {v1} حساب موظف",
  "Orders (30 days)": "الطلبات (30 يومًا)",
  "{v0} bookings, {v1} customers": "{v0} حجز، {v1} عميل",
  "Sign-ups, last 30 days": "التسجيلات خلال آخر 30 يومًا",
  "Collected this month": "المحصّل هذا الشهر",
  "Subscriptions": "الاشتراكات",
  "Most active (30 days)": "الأكثر نشاطًا (30 يومًا)",
  "No owner": "بدون مالك",
  "{v0} orders": "{v0} طلب",
  "Needs attention": "يحتاج إلى متابعة",
  "Suspended": "موقوف",
  "Live": "يعمل",
  "Nothing needs your attention.": "لا شيء يحتاج إلى متابعتك.",
  "Every store on the platform, its owner and its subscription.": "كل متجر على المنصة ومالكه واشتراكه.",
  "Search name, owner or email": "ابحث بالاسم أو المالك أو البريد",
  "All types": "كل الأنواع",
  "All statuses": "كل الحالات",
  "No businesses match.": "لا توجد أنشطة مطابقة.",
  "Business": "النشاط",
  "Owner": "المالك",
  "Subscription": "الاشتراك",
  "Sales (30 days)": "المبيعات (30 يومًا)",
  "Joined": "تاريخ الانضمام",
  "Suspend {v0}? Its website, ordering and admin panel stop working until you reactivate it.": "إيقاف {v0}؟ سيتوقف موقعه والطلبات ولوحة الإدارة حتى تعيد تفعيله.",
  "Business suspended": "تم إيقاف النشاط",
  "Business reactivated": "تمت إعادة تفعيل النشاط",
  "Open website": "فتح الموقع",
  "Sales, all time": "المبيعات منذ البداية",
  "{v0} paid orders": "{v0} طلب مدفوع",
  "{v0} staff": "{v0} موظف",
  "Last sign-in": "آخر تسجيل دخول",
  "Staff": "الموظفون",
  "No staff accounts": "لا توجد حسابات موظفين",
  "Suspend this business": "إيقاف هذا النشاط",
  "Reactivate this business": "إعادة تفعيل هذا النشاط",
  "Its website, ordering and admin panel stop working. Nothing is deleted.": "يتوقف موقعه والطلبات ولوحة الإدارة. لا يُحذف أي شيء.",
  "Its website, ordering and admin panel work again.": "يعود موقعه والطلبات ولوحة الإدارة للعمل.",
  "Disable {v0}? They can no longer sign in.": "تعطيل {v0}؟ لن يتمكن من تسجيل الدخول.",
  "Account disabled": "تم تعطيل الحساب",
  "Account enabled": "تم تفعيل الحساب",
  "Every account on the platform: business owners and their staff.": "كل الحسابات على المنصة: مالكو الأنشطة وموظفوهم.",
  "Search username, name or email": "ابحث باسم المستخدم أو الاسم أو البريد",
  "All roles": "كل الأدوار",
  "No users match.": "لا يوجد مستخدمون مطابقون.",
  "Reset password": "إعادة تعيين كلمة المرور",
  "Disable": "تعطيل",
  "Enable": "تفعيل",
  "Password must be at least 8 characters": "يجب ألا تقل كلمة المرور عن 8 أحرف",
  "Password changed. Share it with {v0} privately.": "تم تغيير كلمة المرور. شاركها مع {v0} بشكل خاص.",
  "Set a new password for {v0}. Their current password stops working right away.": "عيّن كلمة مرور جديدة لـ {v0}. تتوقف كلمة المرور الحالية فورًا.",
  "New password (8+ characters)": "كلمة مرور جديدة (8 أحرف أو أكثر)",
  "Save new password": "حفظ كلمة المرور الجديدة",
  "What businesses pay you, and what their customers pay them.": "ما تدفعه الأنشطة لك، وما يدفعه عملاؤها لها.",
  "Open": "مفتوحة",
  "Failed": "فاشلة",
  "No subscription invoices yet. They appear here once Stripe is connected and businesses subscribe.": "لا توجد فواتير اشتراك بعد. ستظهر هنا بعد ربط Stripe واشتراك الأنشطة.",
  "View invoice": "عرض الفاتورة",
  "No payments yet.": "لا توجد مدفوعات بعد.",
  "Method": "الطريقة",
  "Subscription invoices": "فواتير الاشتراك",
  "Store sales": "مبيعات المتاجر",
  "Enter a plan name and a price": "أدخل اسم الخطة والسعر",
  "Monthly prices businesses can subscribe to. You can still set a custom price for one business from its page.": "الأسعار الشهرية التي يمكن للأنشطة الاشتراك بها. يمكنك أيضًا تحديد سعر خاص لنشاط معيّن من صفحته.",
  "Plan name": "اسم الخطة",
  "e.g. Standard": "مثال: قياسية",
  "Price / month": "السعر / شهر",
  "Add plan": "إضافة خطة",
  "Plan created": "تم إنشاء الخطة",
  "No plans yet. Add your first one above.": "لا توجد خطط بعد. أضف أول خطة بالأعلى.",
  "Stripe": "Stripe",
  "Hidden": "مخفية",
  "Linked": "مرتبطة",
  "Linked on first checkout": "تُربط عند أول دفع",
  "Hide": "إخفاء",
  "Make available": "إتاحة",
  "The latest 200 actions across the platform.": "آخر 200 إجراء على المنصة.",
  "Search activity": "ابحث في النشاط",
  "No activity yet.": "لا يوجد نشاط بعد.",
  "When": "متى",
  "Who": "من",
  "Action": "الإجراء",
  "Details": "التفاصيل",
  "Failed to load the platform overview": "تعذّر تحميل نظرة المنصة العامة",
  "Failed to load businesses": "تعذّر تحميل الأنشطة",
  "Failed to load the business": "تعذّر تحميل النشاط",
  "Failed to update the business": "تعذّر تحديث النشاط",
  "Failed to load users": "تعذّر تحميل المستخدمين",
  "Failed to update the user": "تعذّر تحديث المستخدم",
  "Failed to reset the password": "تعذّرت إعادة تعيين كلمة المرور",
  "Failed to load payments": "تعذّر تحميل المدفوعات",
  "Failed to create the plan": "تعذّر إنشاء الخطة",
  "Failed to update the plan": "تعذّر تحديث الخطة",
  "Super admin access required": "يتطلب صلاحية المشرف العام",
  "You cannot change your own account here": "لا يمكنك تعديل حسابك من هنا",
  "Another super admin can only be changed from the server": "لا يمكن تعديل مشرف عام آخر إلا من الخادم",
  "Business not found": "النشاط غير موجود",
  "User not found": "المستخدم غير موجود",
  "Sending": "جارٍ الإرسال",
  "Could not reach the WhatsApp gateway. Try again in a minute.": "تعذّر الوصول إلى بوابة واتساب. حاول مرة أخرى بعد دقيقة.",
  "WhatsApp disconnected - scan the QR code again, then resend": "انقطع اتصال واتساب - امسح رمز QR من جديد ثم أعد الإرسال",
  "Stopped after 3 failed sends in a row": "توقف بعد 3 محاولات إرسال فاشلة متتالية",
  "No message could be delivered": "تعذّر توصيل أي رسالة",
  "Campaign image is missing - upload it again": "صورة الحملة مفقودة - ارفعها من جديد",
  "The QR code expired. Click Connect to get a new one.": "انتهت صلاحية رمز QR. اضغط على ربط للحصول على رمز جديد.",
  "WhatsApp is not set up on this server yet": "لم يتم إعداد واتساب على هذا الخادم بعد",
  "The platform administrator needs to connect the WhatsApp gateway. Once that's done, you can link your number here with a QR code.": "يجب على مسؤول المنصة ربط بوابة واتساب أولًا. بعد ذلك يمكنك ربط رقمك هنا عبر رمز QR.",
  "Keep your phone connected to the internet so messages can go out.": "أبقِ هاتفك متصلًا بالإنترنت حتى تُرسل الرسائل.",
  "Preparing your QR code...": "جارٍ تجهيز رمز QR...",
  "Customers can reply STOP to stop receiving offers. Each campaign goes to at most 300 customers.": "يمكن للعملاء الرد بكلمة STOP أو «إيقاف» لإيقاف العروض. تصل كل حملة إلى 300 عميل كحد أقصى.",
  "We couldn't open your business. Please sign in again.": "تعذّر فتح نشاطك التجاري. يرجى تسجيل الدخول مرة أخرى.",
};
